import axios from 'axios'
import { Toast, Dialog } from 'vant'
import Cookies from 'js-cookie'
import router from '../router'
import store from '@/store'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // baseURL: 'http://nnh.letuy.cn/index.php/',
  // headers: {
  //   post: {
  //     'Content-Type': 'application/x-www-form-urlencoded'
  //   }
  // },
  timeout: 60000
})

// http request 拦截器
service.interceptors.request.use(
  config => {
    // 发送请求之前做一些处理
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = token
    }
    return config
  }, error => {
    // 当请求异常时做一些处理
  return Promise.reject(error)
})

// http response 拦截器
service.interceptors.response.use((response, promise) => {
  if (response.status === 200 && typeof response.headers.authorization !== 'undefined') {
    localStorage.setItem('token', response.headers.authorization)
  }
  const cacheName = response.config.url + '.' + response.config.method + (response.config.params?JSON.stringify(response.config.params):'')

  // console.log(store.getters.isApp)
  // console.log(cacheName)
  if(store.getters.isApp && response.config.method === 'get'){
    // console.log('cache')
    plus.storage.setItem(cacheName,JSON.stringify(response.data))
    // console.log('缓存接口数据')
    // console.log(cacheName)
  }else{
    console.log('no cache')
  }

  return Promise.resolve(response.data)
}, (err) => {
  if (!err.response) {
    // 断网了

    if( err.config.method === 'get' ) {

      const cacheName = err.config.url + '.' + err.config.method + (err.config.params?JSON.stringify(err.config.params):'')
      console.log('接口数据获取失败')
      console.log(cacheName)
      let data
      if(store.getters.isApp){
        console.log('app')
        data = JSON.parse(plus.storage.getItem(cacheName))
        if(data) {
          // Toast('网络异常，已为您加载缓存数据')
          console.log('网络异常，已为您加载缓存数据')
          return Promise.resolve(data)
        } else {
          console.log(err)
          Toast('网络异常')
          return Promise.reject(err)
        }
      }else{
        if(err.config.url === '/api/member/myinfo'){
          return new Promise((resolve, reject) => {
            let times = 0
            let timer = setInterval(()=>{
              store.dispatch('app/checkIsapp')
              times++
              if(store.getters.isApp){
                data = JSON.parse(plus.storage.getItem(cacheName))

                if(data) {
                  // Toast('网络异常，已为您加载缓存数据!')
                  console.log('网络异常，已为您加载缓存数据')
                  clearInterval(timer)
                  resolve(data)
                } else {
                  clearInterval(timer)
                  reject(err)
                }
              }
              if(times > 4) {
                clearInterval(timer)
                reject(err)
              }
            }, 500)
          })
        } else {
          Toast('网络异常')
          return Promise.reject(err)
        }
      }
    } else {
      Toast('网络异常')
      return Promise.reject(err)
    }
  } else {
    if (err.response.status === 401) {
      Toast({
        message: '用户未登录！',
        type: 'fail'
      })
      router.push({path: '/login'})
    } else if (err.response.status === 422) {
      for (let i in err.response.data.errors) {
        Toast({
          message: err.response.data.errors[i],
          type: 'fail'
        })
      }
    } else if (err.response.status === 500) {
      Toast('服务器开小差')
    } else {
      if (err.response.status !== 200) {
        Toast(err.response.data.message)
      }
    }
    return Promise.reject(err)
  }
})

export default service
